export const appBarHeightLarge = 64;
export const appBarHeightSmall = 64;

const styles = theme => ({
    toolbar: {
        width: '100%',
        paddingRight: 0,
        '@media (max-width: 768px)': {
            paddingLeft: 0,
        }
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.primary.main,
        height: appBarHeightLarge,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        })
    },
    appBarTitle: {
        fontWeight: 100,
        padding: `${theme.spacing(2)}px 10px`,
        color: theme.palette.common.white,
        fontSize: '2.5rem',
        '@media (max-width:767px)': {
            fontSize: '1.75rem',
            padding: `${theme.spacing(2)}px 12px`,
        },
    },
    
    grow: {
        flexGrow: 1
    },
    title: {
        flexGrow: 1,
    },
    tabs: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
});

export default styles;